export default "__VITE_ASSET__BIFHm5G6__"